var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemoday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2,5.8V1.3h-26v4.5H5.4v1c0,2.5,1.4,7.2,6.8,7.7v7.3c0,3.9,4.9,6.7,12,7v19.1h-8v2h18v-2h-8V28.8c7.1-0.2,12-3,12-7v-7.3 C43.6,14,45,9.3,45,6.8v-1H38.2z M7.5,7.8h4.7v4.7C8.7,12,7.8,9.3,7.5,7.8z M36.2,21.8c0,2.5-3.8,5-11,5c-7.2,0-11-2.5-11-5V3.3h22 V21.8z M38.2,12.5V7.8h4.7C42.6,9.3,41.7,12,38.2,12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoday);
export default __webpack_public_path__ + "static/media/demoday.115cef9bd1389498489c0d1a2e0c8641.svg";
export { ForwardRef as ReactComponent };